import { saveToRedux, setUpEvents } from './redux-sync'
import { appConnector } from './singleton'

const fullReload = () => document.location.reload()

appConnector.init().then(() => {
	saveToRedux()

	if (appConnector.extension.isInstalled()) {
		setUpEvents()
		appConnector.eventHandlers.addSnailySignedOutEventHandler(fullReload)
	}
})

export { appConnector }
